// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
/// <summary>
/// Панель для вертикальных таблиц
/// </summary>
import { Resources } from '@shared/localizations/Resources';
import { Color } from '@shared/commons/Graphics';
import { QuickTableEditingInfo } from '../../elements/QuickTable/QuickTableMisc';
import { DynProperty } from '@shared/commons/DynProperty';
import { SessionSettings } from '@shared/commons/SessionSettings';
import { ApplicationPanelWithTable } from '../../panels/ApplicationPanelWithTable';
import { AssetBalanceItem } from '../AssetBalanceItem';
import { ThemeManager } from '../../misc/ThemeManager';
// import { type VerticalPanelDataProviderItem } from './VerticalPanelDataProviderItem';
export class VerticalApplicationPanelNew extends ApplicationPanelWithTable {
    constructor() {
        super();
    }
    // get WrapperRows (): Record<string, VerticalPanelDataProviderItem> {
    //     const tempList = {};// new Dictionary<string, RowPropertyClass>();
    //     for (let i = 0; i < this.VerticalPanelDataProvider.items.length; i++) {
    //         if (Resources.isHidden(this.VerticalPanelDataProvider.items[i].LocalizationKey) || this.VerticalPanelDataProvider.items[i].Hidden) { continue; }
    //         const wrapper = this.VerticalPanelDataProvider.items[i];
    //         tempList[wrapper.Id] = wrapper;
    //     }
    //     return tempList;
    // }
    // set WrapperRows (value) {
    //     if (value === null) { return; }
    //     for (let i = 0; i < this.VerticalPanelDataProvider.items.length; i++) {
    //         const dataItem = this.VerticalPanelDataProvider.items[i];
    //         const wr = value[dataItem.Id];
    //         if (wr) { VerticalApplicationPanelNew.Copy(wr, dataItem); }
    //     }
    //     this.PopulateTable();
    // }
    // static Copy (wr, dataItem): void {
    //     dataItem.visible = wr.visible;
    //     dataItem.SortIndex = wr.SortIndex;
    //     dataItem.callBack(wr.Properties);
    // }
    oncomplete() {
        this.sett = SessionSettings;
        super.oncomplete();
        this.InitializeDataProvider();
    }
    // #region ApplicationPanelWithTable overrided
    jbInit() {
        super.jbInit();
        const quickTable = this.getQuickTable();
        if (!isNullOrUndefined(quickTable)) {
            quickTable.isVertical = true;
            quickTable.columns[0].leftPadding = 48;
        }
    }
    localize() {
        super.localize();
        this.PopulateTable();
    }
    // TODO. Optimize.
    TickAsync() {
        if (!this.get('visible')) {
            return;
        }
        // Update data
        if (this.VerticalPanelDataProvider) {
            this.VerticalPanelDataProvider.UpdateItems();
        }
        super.TickAsync();
    }
    Properties() {
        const prop = super.Properties();
        // prop.push(new DynProperty("dataItems", Serializator.Serialize(VerticalPanelDataProvider.items), DynProperty.STRING, DynProperty.HIDDEN_GROUP));
        return prop;
    }
    callBack(properties) {
        super.callBack(properties);
        this.PopulateTable();
    }
    dispose() {
        if (this.VerticalPanelDataProvider) {
            this.VerticalPanelDataProvider.Source = null;
        } // вызов DisposeHandler
        super.dispose();
    }
    // #region VerticalApplicationPanelNew functions
    /// <summary>
    /// Создание провайдера - описание все возможных итемов и групп
    /// </summary>
    InitializeDataProvider() { }
    /// <summary>
    /// Заполнение таблицы
    /// </summary>
    PopulateTable() {
        const quickTable = this.getQuickTable();
        if (quickTable === null || isNullOrUndefined(this.VerticalPanelDataProvider)) {
            return;
        }
        // Create new rows
        this.VerticalPanelDataProvider.GenerateItems(this.VerticalPanelDataProvider, this.sett);
        // Fill table
        // quickTable.SaveGroupsState();
        // quickTable.SuspendDrawing = true;
        quickTable.ClearAll();
        for (let i = 0; i < this.VerticalPanelDataProvider.generatedTableItems.length; i++) {
            const item = this.VerticalPanelDataProvider.generatedTableItems[i];
            const row = quickTable.AddItem(item);
            row.cells[0].BackColor = item.CellsColor[0] === Color.Empty ? null : item.CellsColor[0];
            row.cells[0].ForeColor =
                item.CellsForeColor[0] === Color.Empty
                    ? ThemeManager.colors.quickTableHeaderForeColor
                    : item.CellsForeColor[0];
            row.cells[1].BackColor = item.CellsColor[1] === Color.Empty ? null : item.CellsColor[1];
            row.cells[1].ForeColor = item.CellsForeColor[1] === Color.Empty ? null : item.CellsForeColor[1];
            //
            if (!item.ToolTipKey) {
                row.cells[1].ToolTip = row.cells[0].ToolTip = Resources.getResource(item.ToolTipKey);
            }
            // если не стринг то надо создать экшн-ячейку
            if (item.DynPropertyControltype !== DynProperty.STRING) {
                this.SetEditingInfo(row, item.DynPropertyControltype);
            }
        }
        quickTable.setGroupByColumnIdx(this.VerticalPanelDataProvider.hideGroupHeaders ? -1 : 2);
    }
    themeChange() {
        super.themeChange();
        const quickTable = this.getQuickTable();
        quickTable === null || quickTable === void 0 ? void 0 : quickTable.rowsArray.forEach((row) => {
            const item = row.item;
            if (!isNullOrUndefined(item)) {
                row.cells[0].ForeColor =
                    item.CellsForeColor[0] === Color.Empty
                        ? ThemeManager.colors.quickTableHeaderForeColor
                        : item.CellsForeColor[0];
            }
        });
    }
    SetEditingInfo(row, controlType) {
        row.cells[1].ReadOnly = false;
        row.cells[1].QuickTableEditingInfo = new QuickTableEditingInfo(controlType);
        // при необходимости дополнить.
    }
    // #endregion
    // #region Misc
    /// <summary>
    ///
    /// </summary>
    SetSource(multiCache, selectedAccs, currentGroupAcc = null) {
        // #region Process selected account
        const processedAccounts = [];
        if (selectedAccs) {
            // режим всех пользователей
            if (selectedAccs === 'All') // hsa: to remove? I think it is not possible to show few accounts in AccountDetailsPanel
             {
                // получаем все аккаунты
                const accountsList = multiCache.getAccounts();
                // заполняем список
                for (let i = 0; i < accountsList.length; i++) {
                    const acc = accountsList[i];
                    if (acc !== null) {
                        if (acc !== null && acc.assetBalanceDefault !== null) {
                            const accItem = new AssetBalanceItem(acc, this.sett, acc.assetBalanceDefault, acc.assetBalanceDefault.Asset);
                            if (accItem !== null && accItem.Account !== null) {
                                processedAccounts.push(accItem);
                            }
                        }
                    }
                }
            }
            // few, not all
            else if (selectedAccs.indexOf(',') !== -1) {
                const accs = selectedAccs.split(',');
                // заполняем список
                for (const str in accs) {
                    const acc = multiCache.GetAccountById(str);
                    if (acc !== null) {
                        if (acc.assetBalanceDefault !== null) {
                            const accItem = new AssetBalanceItem(acc, this.sett, acc.assetBalanceDefault, acc.assetBalanceDefault.Asset);
                            if (accItem !== null && accItem.Account !== null) {
                                processedAccounts.push(accItem);
                            }
                        }
                    }
                }
            }
            // режим одного пользователя
            else {
                // проверка на аккаунт-группу
                // TODO
                const groupAcc = null; // multiCache.AccountsGroupManager.GetGroupByName(selectedAccs);
                if (groupAcc !== null) {
                    currentGroupAcc = groupAcc;
                    for (const it in groupAcc.Accounts) {
                        const item = groupAcc[it];
                        if (item.Acc !== null) {
                            if (item.Acc.assetBalanceDefault !== null) {
                                const accItem = new AssetBalanceItem(item.Acc, this.sett, item.Acc.assetBalanceDefault, item.Acc.assetBalanceDefault.Asset);
                                processedAccounts.push(accItem);
                            }
                        }
                    }
                }
                else {
                    const acc = multiCache.GetAccountById(selectedAccs);
                    // TODO
                    if (acc !== null /* && acc.assetBalanceDefault !== null */) {
                        const accItem = new AssetBalanceItem(acc, this.sett, acc.assetBalanceDefault, null /* acc.assetBalanceDefault.Asset */);
                        if (accItem !== null && accItem.Account !== null) {
                            processedAccounts.push(accItem);
                        }
                    }
                }
            }
        }
        else {
            const accountsList = multiCache.getAccounts();
            if (accountsList !== null &&
                accountsList.length > 0 &&
                accountsList[0] !== null /* && accountsList[0] is Account */) {
                const acc = accountsList[0];
                if (acc !== null && acc.assetBalanceDefault !== null) {
                    const accItem = new AssetBalanceItem(acc, this.sett, acc.assetBalanceDefault, acc.assetBalanceDefault.Asset);
                    if (accItem !== null && accItem.Account !== null) {
                        processedAccounts.push(accItem);
                    }
                }
            }
        }
        //
        if (!isNullOrUndefined(this.VerticalPanelDataProvider)) {
            this.VerticalPanelDataProvider.Source = processedAccounts;
        }
        // #endregion
    }
}
ApplicationPanelWithTable.extendWith(VerticalApplicationPanelNew, {});
